// Leave the salon page for /login or /signup/client, stashing the in-progress
// booking so it can be resumed when the client comes back. Shared by the
// standalone AuthPromptModal (favourite / gift card / product contexts) and
// the auth step inside ConfirmBookingModal (booking context), so the two can
// never drift on what gets saved or where the user is sent.

export const PENDING_BOOKING_KEY = 'pendingBooking';

export function stashPendingBooking(pendingBookingData) {
  if (!pendingBookingData) return;
  try {
    localStorage.setItem(PENDING_BOOKING_KEY, JSON.stringify({
      ...pendingBookingData,
      returnUrl: window.location.pathname,
      savedAt: Date.now(),
    }));
  } catch (e) { /* storage unavailable */ }
}

// target: 'login' | 'signup'
export function redirectToAuth(history, pendingBookingData, target) {
  stashPendingBooking(pendingBookingData);
  const returnUrl = encodeURIComponent(window.location.pathname);
  const path = target === 'signup' ? '/signup/client' : '/login';
  history.push(`${path}?returnUrl=${returnUrl}`);
}
